const UNSAFE_PATH_PATTERNS: RegExp[] = [/^\/billing-schedules\/[^/]+\/edit/]

export const isUnsafeToReload = (pathname: string): boolean =>
  UNSAFE_PATH_PATTERNS.some(pattern => pattern.test(pathname))
